<template>
  <div class="info">
    <lb-table
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '提现时间', prop: 'createTime', minWidth: '120' },
        // { label: '提现类型', prop: 'typeLabel', minWidth: '220' },
        { label: '提现方式', prop: 'applyTypeLabel', minWidth: '120' },
        {
          label: '提现账号', prop: 'account', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p>账号:{scope.row.account}</p>
                <p>名称:{scope.row.name}</p>
              </div>

            )
          }
        },
        {
          label: '提现金额', prop: 'applyAmount', minWidth: '120',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.applyAmount).toFixed(2)}</div>
            )
          }
        },
        {
          label: '手续费', prop: 'handlingFee', minWidth: '120',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.handlingFee).toFixed(2)}</div>
            )
          }
        },
        {
          label: '实际到账', prop: 'receivedAmount', minWidth: '120',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.receivedAmount).toFixed(2)}</div>
            )
          }
        },
        { label: '状态', prop: 'statusLabel', minWidth: '120' }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: false
    }
  },
  watch: {
    phone (val, vall) {
      this.phone = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        phone: this.phone,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.matrixServerGetCommissionApplyList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

